<template>
    <v-card
        :height="$vuetify.breakpoint.mdAndUp ? '480' : ''"
        :elevation="elevation"
        :ripple="false"
        class="pa-4"
        @click="setFormType(1)"
    >
        <v-radio-group
            v-if="$vuetify.breakpoint.mdAndUp"
            v-model="formType"
            :hide-details="true"
            class="mt-0"
            dense
        >
            <v-radio value="1">
                <template v-slot:label>
                    <span style="font-size:20px;color:#444444"
                        ><TranslatableStringComponent :tstring="{string: 'lineByLine'}" /></span
                    >
                </template>
            </v-radio>
        </v-radio-group>

        <v-card-subtitle class="px-0"
            >
            <TranslatableStringComponent :tstring="{string: 'enterIndividualPartNumbersAndQuantities'}" />
        </v-card-subtitle
        >
        <v-container
            :style="
                $vuetify.breakpoint.mdAndUp
                    ? 'height:304px; overflow-y:auto'
                    : ''
            "
        >
            <v-row v-for="(item, index) in textFieldValues" :key="index">
                <v-col cols="9" md="6" class="pa-0 pr-4 mb-4">
                    <ValidationProvider
                        :rules="
                            `${item.qty && formType === '1' ? 'required' : ''}`
                        "
                    >
                        <div slot-scope="{ errors }" style="position:relative">
                            <span
                                v-if="$vuetify.breakpoint.mdAndUp"
                                class="validationMessage"
                            >
                                {{ errors[0] }}
                            </span>
                            <v-text-field
                                v-model="item.pn"
                                label="Part No #"
                                outlined
                                :error="
                                    !$vuetify.breakpoint.mdAndUp &&
                                        errors.length > 0
                                "
                                dense
                                :hide-details="true"
                            ></v-text-field></div
                    ></ValidationProvider>
                </v-col>
                <v-col cols="3" md="3" class="pa-0 mb-4">
                    <ValidationProvider
                        :rules="
                            `${item.pn && formType === '1' ? 'required' : ''}`
                        "
                    >
                        <div slot-scope="{ errors }" style="position:relative">
                            <span
                                v-if="$vuetify.breakpoint.mdAndUp"
                                class="validationMessage"
                            >
                                {{ errors[0] }}
                            </span>
                            <v-text-field
                                v-model="item.qty"
                                type="number"
                                small
                                :label="localize('qty')"
                                outlined
                                :error="
                                    !$vuetify.breakpoint.mdAndUp &&
                                        errors.length > 0
                                "
                                dense
                                :hide-details="true"
                            ></v-text-field>
                        </div>
                    </ValidationProvider>
                </v-col>
            </v-row>
        </v-container>
        <div>
            <v-btn
                color="primary"
                outlined
                :block="!$vuetify.breakpoint.mdAndUp"
                dense
                small
                @click="addTextFieldRow()"
            >
                <span
                    ><fa :icon="['fal', 'plus']" class="fa-sm mr-1" /> <TranslatableStringComponent :tstring="{string: 'addEntryFields'}" /></span
                >
            </v-btn>
        </div>
    </v-card>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { ValidationProvider } from 'vee-validate'
import handleSnackbar from '~/mixins/handleSnackbar'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'

const { mapFields, mapMultiRowFields } = createHelpers({
    getterType: 'getBulkOrderPadField',
    mutationType: 'updateBulkOrderPadField'
})
export default {
    name: 'BulkOrderPadLineByLine',
    components: {
        ValidationProvider,
        TranslatableStringComponent,
    },
    mixins: [handleSnackbar],
    data() {
        return {
            partNoFieldNames: ['pn0', 'pn1', 'pn2', 'pn3', 'pn4'],
            qtyFieldNames: ['qty0', 'qty1', 'qty2', 'qty3', 'qty4']
        }
    },
    computed: {
        ...mapFields('bulkOrderPad', ['formType']),
        ...mapMultiRowFields('bulkOrderPad', ['textFieldValues']),
        ...mapState('bulkOrderPad', ['dialog', 'availableBulkOrderItems']),
        ...mapState('cart', ['cartProducts']),
        ...mapGetters({
            selectedPns: 'bulkOrderPad/selectedPns',
            isCartSaved: 'savedCarts/isCartSaved',
            isLoggedIn: 'auth/isLoggedIn',
            isProduction: 'auth/isProduction'
        }),
        elevation() {
            if (this.$vuetify.breakpoint.mdAndUp) {
                return this.formType === 1 ? 10 : 2
            } else {
                return 0
            }
        }
    },
    methods: {
        ...mapMutations('bulkOrderPad', ['addTextFieldRow']),
        setFormType(type) {
            if (type === 1) {
                this.formType = '1'
            } else {
                this.formType = '2'
            }
        }
    }
}
</script>

<style></style>
